import React, { useEffect } from "react";
import { useAuth } from "../../contexts/auth";
import { logout } from "../../reducers/auth";
import { setAuthentication } from "../../utils/localStorage";
// Chakra imports
import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Image,
  Link,
  Switch,
  Text,
  useColorModeValue,
  useDisclosure, 
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
// Assets
import avatar0 from "assets/img/avatars/profile-pic.png";
import avatar2 from "assets/img/avatars/avatar2.png";
import avatar3 from "assets/img/avatars/avatar3.png";
import avatar4 from "assets/img/avatars/avatar4.png";
import avatar5 from "assets/img/avatars/avatar5.png";
import avatar6 from "assets/img/avatars/avatar6.png";
import ImageArchitect1 from "assets/img/ImageArchitect1.png";
import ImageArchitect2 from "assets/img/ImageArchitect2.png";
import ImageArchitect3 from "assets/img/ImageArchitect3.png";
import ProfileBgImage from "assets/img/ProfileBackground.png";
import {
  FaCube,
  FaFacebook,
  FaInstagram,
  FaLock,
  FaPenFancy,
  FaPlus,
  FaSignOutAlt,
  FaTwitter,
} from "react-icons/fa";
import { IoDocumentsSharp } from "react-icons/io5";
import MyOrdersTable from "views/Custom/MyOrdersTable";
import useGetMe from "../../hooks/useGetMe";
import useLogout from "../../hooks/useLogout";
import UpdatePassword from "../../modals/UpdatePassword";



function Profile() {

  const { auth, authDispatch } = useAuth();
  const { setGettingMe, unauthorized  } = useGetMe();
  const { setLoggingOut } = useLogout();

  const { isOpen: isOpenPassword, onOpen: onOpenPassword, onClose: onClosePassword } = useDisclosure();


  // Chakra color mode
  const textColor = useColorModeValue("gray.700", "white");
  const bgProfile = useColorModeValue(
    "hsla(0,0%,100%,.8)",
    "linear-gradient(112.83deg, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0) 110.84%)"
  );
  const borderProfileColor = useColorModeValue(
    "white",
    "rgba(255, 255, 255, 0.31)"
  );
  const emailColor = useColorModeValue("gray.400", "gray.300");


  const logoutUser = () => setLoggingOut(true);

  useEffect(() => {
    setGettingMe(true);
  }, []);

  useEffect(() => {
    if (unauthorized) {
      logoutUser();
    }
  }, [unauthorized]);
  

  return (
    <Flex direction="column">
      <Box
        mb={{ sm: "205px", md: "75px", xl: "70px" }}
        borderRadius="15px"
        px="0px"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        align="center"
      >
        <Box
          bgImage={ProfileBgImage}
          w="100%"
          h="300px"
          borderRadius="25px"
          bgPosition="50%"
          bgRepeat="no-repeat"
          position="relative"
          display="flex"
          justifyContent="center"
        >
          <Flex
            direction={{ sm: "column", md: "row" }}
            mx="1.5rem"
            maxH="330px"
            w={{ sm: "90%", xl: "95%" }}
            justifyContent={{ sm: "center", md: "space-between" }}
            align="center"
            backdropFilter="saturate(200%) blur(50px)"
            position="absolute"
            boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.02)"
            border="2px solid"
            borderColor={borderProfileColor}
            bg={bgProfile}
            p="24px"
            borderRadius="20px"
            transform={{
              sm: "translateY(45%)",
              md: "translateY(110%)",
              lg: "translateY(160%)",
            }}
          >
            <Flex
              align="center"
              mb={{ sm: "10px", md: "0px" }}
              direction={{ sm: "column", md: "row" }}
              w={{ sm: "100%" }}
              textAlign={{ sm: "center", md: "start" }}
            >
              <Avatar
                me={{ md: "22px" }}
                src={avatar0}
                w="80px"
                h="80px"
                borderRadius="15px"
              />
              <Flex direction="column" maxWidth="100%" my={{ sm: "14px" }}>
                <Text
                  fontSize={{ sm: "lg", lg: "xl" }}
                  color={textColor}
                  fontWeight="bold"
                  ms={{ sm: "8px", md: "0px" }}
                >
                  { auth.firstName } { auth.lastName }
                </Text>
                <Text
                  fontSize={{ sm: "sm", md: "md" }}
                  color={emailColor}
                  fontWeight="semibold"
                >
                   { auth.email }
                </Text>
                { auth.mobile != null 
                  ?     <Text
                  fontSize={{ sm: "sm", md: "md" }}
                  color={emailColor}
                  fontWeight="semibold"
                >
                   { auth.mobile }
                </Text>
                  : null 
                }
            
              </Flex>
            </Flex>
            <Flex
              direction={{ sm: "column", lg: "row" }}
              w={{ sm: "100%", md: "50%", lg: "auto" }}
            >
              <Button p="0px" 
                bg="transparent" 
                _hover={{ bg: "none" }}
                onClick={onOpenPassword}
                >
                <Flex
                  align="center"
                  w={{ lg: "135px" }}
                  borderRadius="15px"
                  justifyContent="center"
                  py="10px"
                  cursor="pointer"
                >
                  <Icon as={FaLock} me="6px" />
                  <Text fontSize="xs" color={textColor} fontWeight="bold">
                    CHANGE PASSWORD
                  </Text>
                </Flex>
              </Button>

              <Button p="0px" 
                bg="transparent" 
                _hover={{ bg: "none" }}
                onClick={logoutUser}
                >
                <Flex
                  align="center"
                  w={{ lg: "135px" }}
                  borderRadius="15px"
                  justifyContent="center"
                  py="10px"
                  cursor="pointer"
                >
                  <Icon as={FaSignOutAlt} me="6px" />
                  <Text fontSize="xs" color={textColor} fontWeight="bold">
                    LOGOUT
                  </Text>
                </Flex>
              </Button>
            </Flex>



          </Flex>
        </Box>
      </Box>
      
      { auth && auth.role == 'customer'
        ? <Card my="24px" mt="64px" overflowX={{ sm: "scroll", xl: "hidden" }}>
          <CardHeader p="12px 5px" mb="12px">
            <Flex direction="column">
              <Text fontSize="lg" color={textColor} fontWeight="bold">
                My Orders
              </Text>
            </Flex>
          </CardHeader>
          <CardBody px="5px">
            <MyOrdersTable />
          </CardBody>
      </Card>
        : null
      }

                   
      <UpdatePassword 
        isOpen={isOpenPassword}
        onClose={onClosePassword}
        // successCallback={() => setGettingCustomers(true)}
      />
      
    </Flex>
  );
}

export default Profile;
